// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".citation__QVWXd{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;margin:1rem 0;font-style:italic;white-space:pre-line}.citation__QVWXd .author__8B7Xq{margin-top:1rem;text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"citation": "citation__QVWXd",
	"author": "author__8B7Xq"
};
export default ___CSS_LOADER_EXPORT___;
